import React, { useState } from "react";
import { CodedProperty, ValidationResult } from "sprint-common-web";

import { UpdateFileRecordVideoSoundtracksRequest } from "../../../../../../../../common/api/master-api/file-records/update/soundtrack/UpdateFileRecordVideoSoundtracksRequest";
import { useFileRecordApi } from "../../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { ensureVideoFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";
import { EditVideoSoundtrackForm } from "./EditVideoSoundtrackForm";

export interface EditSoundtrackAsideContentProps {
    onClose(): void;
}

export const EditSoundtrackAsideContent = (props: EditSoundtrackAsideContentProps): JSX.Element => {
    const { onClose } = props;
    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordVideoSoundtracks } = useFileRecordApi();

    const updateSoundtrack = (soundtracks: CodedProperty[]) => {
        ensureVideoFileRecordDetails(fileRecordDetails);

        const request: UpdateFileRecordVideoSoundtracksRequest = {
            id: fileRecordDetails.id,
            soundtracks: soundtracks ? soundtracks : []
        };

        setIsLoading(true);

        updateFileRecordVideoSoundtracks(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    soundtracks
                });

                onClose();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <EditVideoSoundtrackForm
            isLoading={isLoading}
            onCancel={onClose}
            onSubmit={updateSoundtrack}
            validationResult={validationResult}
        />
    );
};
